import { memo } from 'react'

import './product-identifiers.scss'

type Props = {
  productId: string
  productIdLabel: string
  manufacturerName: string
  manufacturerProductIdentifier: string
}
const ProductIdentifiers = ({
  productId,
  productIdLabel,
  manufacturerName,
  manufacturerProductIdentifier,
}: Props) => {
  const copySkuId = async (productId: string) => {
    await navigator.clipboard.writeText(productId)
  }

  return (
    <section className="product-identifiers">
      {productId === manufacturerProductIdentifier ? (
        <div data-testid="product-identifier-combined">
          <span className="label">{`${productIdLabel} (${manufacturerName} Dustin): `}</span>
          <span data-testid="product-identifier-combined-id">{productId}</span>
        </div>
      ) : (
        <>
          <div data-testid="product-identifier-manufacturer">
            <span className="label">{`${manufacturerName} ${productIdLabel.toLowerCase()}: `}</span>
            <span data-testid="product-identifier-manufacturer-id">
              {manufacturerProductIdentifier}
            </span>
          </div>
          <div className="seperator">|</div>
          <div data-testid="product-identifier-dustin">
            <span className="label">{`Dustin ${productIdLabel.toLowerCase()}: `}</span>
            <span data-testid="product-identifier-dustin-id" onClick={() => copySkuId(productId)}>
              {productId}
            </span>
          </div>
        </>
      )}
    </section>
  )
}

export default memo(ProductIdentifiers)
